import { render, staticRenderFns } from "./StockTakingDeleteModal.vue?vue&type=template&id=f9556826"
import script from "./StockTakingDeleteModal.vue?vue&type=script&lang=ts"
export * from "./StockTakingDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports